import { ChangeDetectionStrategy, Component } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { NavigationStart, Router } from '@angular/router'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { TranslateService } from '@ngx-translate/core'
import { filter, switchMap } from 'rxjs/operators'
import { SessionQuery } from './core'
import { UserQuery } from './user/state/user.query'
import { UserService } from './user/state/user.service'

@UntilDestroy()
@Component({
  selector: 'app-root',
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- relies on pre-v22 default
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  title = 'Flexit Select'

  constructor(
    private translate: TranslateService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private userQuery: UserQuery,
    private userService: UserService,
    private sessionQuery: SessionQuery,
    private router: Router,
  ) {
    this.translate.setFallbackLang('en')
    this.translate.use('en')
    this.matIconRegistry.addSvgIcon('file-pdf', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/file-pdf.svg'))
    this.matIconRegistry.addSvgIcon('dxf', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/dxf.svg'))

    this.matIconRegistry.addSvgIcon('FRONT', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/FRONT.svg'))
    this.matIconRegistry.addSvgIcon('TOP', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/TOP.svg'))
    this.matIconRegistry.addSvgIcon('LEFT', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/LEFT.svg'))
    this.matIconRegistry.addSvgIcon('RIGHT', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/RIGHT.svg'))
    this.matIconRegistry.addSvgIcon('TOPLEFT', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/TOPLEFT.svg'))
    this.matIconRegistry.addSvgIcon('TOPRIGHT', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/TOPRIGHT.svg'))

    this.userQuery.settings$.pipe(untilDestroyed(this)).subscribe({
      next: settings => {
        if (settings?.UILanguage && translate.currentLang() !== settings.UILanguage) {
          this.translate.use(settings.UILanguage)
        }
      },
    })

    // If user is logged in
    this.sessionQuery.isLoggedIn$
      .pipe(
        filter(result => result && !this.userQuery.hasSettings),
        switchMap(() => {
          return this.userService.getSettings()
        }),
        untilDestroyed(this),
      )
      .subscribe()

    // If user is logged out
    this.sessionQuery.isLoggedIn$
      .pipe(
        filter(result => !result),
        untilDestroyed(this),
      )
      .subscribe({
        next: () => {
          this.translate.use('en')
        },
      })

    // Removes # from the url in case it's still there
    // TODO: REMOVE WHEN PLUGIN IS UPDATED
    this.router.events.pipe(untilDestroyed(this)).subscribe(event => {
      if (event instanceof NavigationStart) {
        if (!!event.url && event.url.match(/^\/#/)) {
          this.router.navigate([event.url.replace('/#', '')])
        }
      }
    })
  }
}
